import { useCallback, useEffect, useState } from 'react';
import { apiUrl } from '../../config/api';

/** Loads the two homepage banner carousels. */
const useCarousel = () => {
  const [firstCarousel, setFirstCarousel] = useState([]);
  const [secondCarousel, setSecondCarousel] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchCarousel = useCallback(async (signal) => {
    setLoading(true);
    try {
      const response = await fetch(apiUrl('/api/all-carousels'), { signal });
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setFirstCarousel(Array.isArray(data.first_carousal) ? data.first_carousal : []);
      setSecondCarousel(Array.isArray(data.second_carousal) ? data.second_carousal : []);
      setError(null);
    } catch (err) {
      if (err.name !== 'AbortError') setError(err.message);
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    fetchCarousel(controller.signal);
    return () => controller.abort();
  }, [fetchCarousel]);

  return { firstCarousel, secondCarousel, loading, error, fetchCarousel };
};

export default useCarousel;
